import { EmployerFooter, EmployerHeader } from '@seek/adv-header-footer';
import { createUrlResolver } from '@seek/melways-sites';
import {
  Box,
  Card,
  Heading,
  Page,
  PageBlock,
  Stack,
  Text,
  TextLink,
} from 'braid-design-system';

import { Nav } from 'src/components/Nav/Nav';
import { PuzzleIcon } from 'src/components/PuzzleIcon';
import { useConfig } from 'src/utils/hooks/useContext';

export const ClientErrorPage = () => {
  const { language, environment, site } = useConfig();

  const headerFooterProps = {
    site,
    locale: language,
    isStaging: environment === 'development',
    identityContext: null,
  };

  const resolveUrl = createUrlResolver({ site, language });
  const contactUsUrl = resolveUrl({ path: '/contactus' });

  return (
    <Box
      translate={
        // The initial motivation for this error page is crashes due to React + Google Translate
        // Translating the error page means we could crash inside the error boundary, which would be unhelpful
        'no'
      }
    >
      <Page footer={<EmployerFooter {...headerFooterProps} />}>
        <EmployerHeader {...headerFooterProps} />
        <Nav activeTab="error-page" />

        <PageBlock width="small">
          <Box paddingY="xlarge">
            <Card>
              <Box padding="medium">
                <Stack space="xlarge" align="center">
                  <PuzzleIcon />
                  <Heading level="3" align="center">
                    Something went wrong
                  </Heading>

                  <Text align="center" tone="secondary">
                    We’ve had a problem with this page. Try refreshing the page,
                    and if the problem persists,{' '}
                    <TextLink href={contactUsUrl} target="_blank">
                      contact us
                    </TextLink>
                    .
                  </Text>
                </Stack>
              </Box>
            </Card>
          </Box>
        </PageBlock>
      </Page>
    </Box>
  );
};
